export default "__VITE_ASSET__DTrGSrD8__"